export class TradeNameFilter {
    public IncludeInactive?: boolean;
}

export default TradeNameFilter;